import {unreachableCase} from "../../../../../../../utils/typescript";
import {ToolState} from "./tools";

export function chooseCursor({
  toolState,
  isHoldingSpace,
  isHoldingAlt,
  isPanning,
}: {
  toolState: ToolState;
  isHoldingSpace: boolean;
  isHoldingAlt: boolean;
  isPanning: boolean;
}): string {
  if (isPanning) {
    return "grabbing";
  }

  if (isHoldingSpace) {
    return "grab";
  }

  switch (toolState.tool) {
    case "select":
      {
        if (toolState.dragging != null) {
          return toolState.dragging.isDuplicate ? "copy" : "grabbing";
        }
        if (isHoldingAlt) {
          return "alias";
        }
      }
      break;

    case "pan": {
      return "grab";
    }

    case "createNode": {
      return "copy";
    }

    case "createConnection": {
      return "copy";
    }

    default:
      unreachableCase(toolState);
  }

  return "default";
}
